import { SvgIcon, SvgIconProps } from '@mui/material'

const SettingsIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clip-path="url(#clip0_542_379)">
        <path
          d="M19.93 12.98C19.97 12.66 20 12.34 20 12C20 11.66 19.97 11.34 19.93 11.02L22.04 9.37C22.23 9.22 22.28 8.95 22.16 8.73L20.16 5.27C20.04 5.05 19.77 4.97 19.55 5.05L17.06 6.05C16.54 5.65 15.98 5.32 15.37 5.07L14.99 2.42C14.96 2.18 14.75 2 14.5 2H10.5C10.25 2 10.04 2.18 10.01 2.42L9.63 5.07C9.02 5.32 8.46 5.66 7.94 6.05L5.45 5.05C5.22 4.96 4.96 5.05 4.84 5.27L2.84 8.73C2.71 8.95 2.77 9.22 2.96 9.37L5.07 11.02C5.03 11.34 5 11.67 5 12C5 12.33 5.03 12.66 5.07 12.98L2.96 14.63C2.77 14.78 2.72 15.05 2.84 15.27L4.84 18.73C4.96 18.95 5.23 19.03 5.45 18.95L7.94 17.95C8.46 18.35 9.02 18.68 9.63 18.93L10.01 21.58C10.04 21.82 10.25 22 10.5 22H14.5C14.75 22 14.96 21.82 14.99 21.58L15.37 18.93C15.98 18.68 16.54 18.34 17.06 17.95L19.55 18.95C19.78 19.04 20.04 18.95 20.16 18.73L22.16 15.27C22.28 15.05 22.23 14.78 22.04 14.63L19.93 12.98ZM12.5 15.5C10.57 15.5 9 13.93 9 12C9 10.07 10.57 8.5 12.5 8.5C14.43 8.5 16 10.07 16 12C16 13.93 14.43 15.5 12.5 15.5Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_542_379">
          <rect
            width="24"
            height="24"
            fill="currentColor"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </SvgIcon>
  )
}

export default SettingsIcon
